// extracted by css-extract-rspack-plugin
export default {"OfferTermsCheckbox":"sputnik__OfferTermsCheckbox__PfNK9","offerTermsCheckbox":"sputnik__OfferTermsCheckbox__PfNK9"};